import { motion } from "framer-motion";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "../components/ui/accordion";

export const FAQS = [
  {
    q: "How fast can you get to me?",
    a: "Average response inside Winnipeg is about 20 minutes, depending on traffic and weather. Our vans are staged across the city and we dispatch 24/7 — nights, weekends and holidays included.",
  },
  {
    q: "How much does a lockout cost?",
    a: "Every job gets an exact price over the phone or by text before we roll — no surprises and no after-hours markup games. Cost depends on your vehicle or lock type, so call or send the quote form for a firm number.",
  },
  {
    q: "I lost all my car keys. Can you still help?",
    a: "Yes. We originate brand-new transponder and smart keys from scratch, cut and programmed to your vehicle's immobilizer right where it sits — no tow to the dealership needed.",
  },
  {
    q: "Will unlocking my car or door cause any damage?",
    a: "No. We use non-destructive entry techniques and professional tools. Your paint, weather stripping, door frames and locks stay exactly as we found them.",
  },
  {
    q: "Do you program key fobs for all makes and models?",
    a: "Nearly all — domestic, Japanese, Korean and European. Tell us your year, make and model when you call and we'll confirm coverage and price before dispatch.",
  },
  {
    q: "Can you rekey my house after I move in or lose my keys?",
    a: "Absolutely. We rekey or replace residential locks on the spot, so old keys stop working immediately. It's one of the smartest first moves in a new home.",
  },
  {
    q: "Do you really work in the middle of winter?",
    a: "Yes — Winnipeg winters are exactly why we exist. -40° doesn't stop us, and frozen locks are a routine call for us.",
  },
  {
    q: "Which areas do you cover?",
    a: "All of Winnipeg — Downtown, St. Boniface, Transcona, St. Vital, Fort Garry, St. James, River Heights and everywhere in between, plus Headingley and the Perimeter area.",
  },
];

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-white border-y border-zinc-200">
    <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ type: "spring", stiffness: 100, damping: 20 }}
        className="lg:col-span-5"
      >
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-400 mb-4">FAQ</p>
        <h2 className="font-heading text-3xl md:text-5xl font-semibold tracking-tight text-zinc-950">
          Questions? <span className="text-brand">Answered.</span>
        </h2>
        <p className="mt-6 text-base leading-relaxed text-zinc-600 max-w-md">
          The things Winnipeg drivers and homeowners ask us most. Something else
          on your mind? Call or text — a real locksmith picks up.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ type: "spring", stiffness: 100, damping: 20, delay: 0.1 }}
        className="lg:col-span-7"
      >
        <Accordion type="single" collapsible data-testid="faq-accordion" className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-zinc-200">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="font-heading text-base md:text-lg font-medium tracking-tight text-zinc-950 hover:no-underline hover:text-brand py-6"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${i}`}
                className="text-sm md:text-base leading-relaxed text-zinc-600"
              >
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </div>
  </section>
);
